import { styled, Content, Box, spacingLevel, Base } from '../../design-system'

const termWidth = spacingLevel(5) + 'px'

export const HeadingDescription = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  color: ${({ theme }) => theme.color('contentAlt')};
`

export const HeadingDescriptionLabel = styled(Base.withComponent('span'))`
  ${({ theme }) => theme.font('controlLabel')}
  display: inline-block;
  width: ${termWidth};
`

export const HeadingDescriptionMatchedIndent = styled(
  Base.withComponent('span'),
)`
  display: inline-block;
  width: ${termWidth};
`

export const HeadingDescriptionValue = Content
